import Button from '@material-ui/core/Button';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import closeSVG from 'assets/img/close.svg';
import { useEffect, useState } from 'react';
import './BottomSheet.scss';

export default function BottomSheet({
	children,
	button,
	Component,
	openSheet,
	style,
	hasTitle,
	withCloseBtn,
	func,
	withFeaze,
	wrapperStyle,
}) {
	const [state, setState] = useState(openSheet || false);

	const toggleDrawer = (open) => (event) => {
		if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return;
		}
		if (openSheet !== false) setState(open);
	};

	const handleClose = () => {
		func?.();
		setState(false);
	};

	useEffect(() => {
		if (openSheet) {
			setState(true);
		} else setState(false);
	}, [openSheet]);

	if (!state) {
		setTimeout(() => {
			localStorage.setItem('FIRSTPHASE', false);
		}, 1000);
	}

	return (
		<section id="bottom-sheet" style={wrapperStyle}>
			<Button style={style} onClick={withFeaze ? () => {} : toggleDrawer(true)}>
				{button} {children}
			</Button>
			<SwipeableDrawer
				anchor="bottom"
				open={state}
				onClose={withFeaze ? () => {} : handleClose}
				onOpen={withFeaze ? () => {} : toggleDrawer(true)}
			>
				<div className="container-hader-bottom-sheet">
					{hasTitle && <h2 className="container-hader-bottom-sheet">{hasTitle}</h2>}

					{withCloseBtn && (
						<div onClick={withFeaze ? () => {} : toggleDrawer(false)}>
							<img src={closeSVG} alt="" />
						</div>
					)}
				</div>
				{Component}
			</SwipeableDrawer>
		</section>
	);
}
